<div fxLayout="row" class="background">
  <div fxFlex="75" fxFlexOffset="12%">
    <section id="header">
      <h1 class="h1Header">PEDIDOS ACTIVOS</h1>
    </section>


    <div fxLayout="row" class="tablaCom">
      <div fxFlex=120 fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">

          <mat-form-field appearance="outline">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ingresar número de pedido" #input>
          </mat-form-field>

          <mat-table [dataSource]="dataSource" class="tabla">
            <!-- Codigo Column -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="table-header"> ID</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">{{order.cdOrder}}</mat-cell>
            </ng-container>

            <!-- Store Column -->
            <ng-container matColumnDef="comercio">
              <mat-header-cell *matHeaderCellDef class="table-header">Comercio </mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsStoreName}}</mat-cell>
            </ng-container>

            <!-- User Column -->
            <ng-container matColumnDef="usuario">
              <mat-header-cell *matHeaderCellDef class="table-header">Usuario</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsUserName}}<br> {{order.dsPhone}}
              </mat-cell>
            </ng-container>

            <!-- Address Column -->
            <ng-container matColumnDef="direccion">
              <mat-header-cell *matHeaderCellDef class="table-header">Dirección</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsAddress}} </mat-cell>
            </ng-container>

            <!-- Items Column -->
            <ng-container matColumnDef="items">
              <mat-header-cell *matHeaderCellDef class="table-header"> Items</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                <button mat-button (click)="openOrder(order.cdOrder)">Ver</button>
              </mat-cell>
            </ng-container>

            <!-- total Column  -->
            <ng-container matColumnDef="total">
              <mat-header-cell *matHeaderCellDef class="table-header">Total</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">{{order.qtTotal}}</mat-cell>
            </ng-container>

            <!-- status Column  -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="table-header">Estado</mat-header-cell>
              <mat-cell *matCellDef="let order" [ngClass]="{
            'green-text' : order.nmStatus == 1 || order.nmStatus == 5 || order.nmStatus == 6 && 
            'newOrder: order.nmStatus == 0'}" class="table-content">
              <p>{{order.nmStatus | ordersStatus}}</p>
              <p *ngIf="order.nmStatus == 1" class="delay-text">Demora {{order.nmStoreDelayMinutes}} minutos</p></mat-cell>
            </ng-container>

            <!-- Options Column -->

            <ng-container matColumnDef="opciones">
              <mat-header-cell *matHeaderCellDef class="table-header">Opciones</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                <button mat-button [matMenuTriggerFor]="belowMenu">Opciones</button>
                <mat-menu #belowMenu="matMenu" yPosition="below">
                  <!--<button mat-menu-item (click)="editOrder()">Editar pedido</button>-->
                  <button mat-menu-item *ngIf="order.nmStatus == 0" (click)="AceptOrder(order.cdOrder)">Aceptar
                    pedido</button>
                  <button mat-menu-item *ngIf="order.nmStatus == 0"
                    (click)="CancelRejectOrder(order.cdOrder, order.nmStatus)">Rechazar pedido</button>
                  <!-- <button mat-menu-item *ngIf="order.nmStatus == 1"
                    (click)="CancelRejectOrder(order.cdOrder, order.nmStatus)">Cancelar pedido</button> -->
                  <button mat-menu-item *ngIf="order.nmStatus === 6"
                    (click)="ConfirmOrder(order.cdOrder)">Finalizar pedido</button>
                  <button mat-menu-item *ngIf="order.nmStatus == 1"
                    (click)="OnTheWay(order.cdOrder)">
                      {{order.isShipping ? "En Viaje" : "Listo para retirar"}}
                    </button>
                </mat-menu>
              </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>
          <div *ngIf="dataSource.filteredData.length === 0" fxLayout="row" fxLayoutAlign="center center">
            <span class="cardHeader">
              No se encontraron pedidos con ese código</span>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

</div>